import React from 'react';
import { FadeIn } from './FadeIn';
interface ListProps {
  items: string[];
  columns?: 1 | 2;
}
export function CheckList({
  items,
  columns = 1
}: ListProps) {
  return <ul className={`grid gap-4 ${columns === 2 ? 'md:grid-cols-2' : 'grid-cols-1'}`} data-id="element-8">
      {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-9">
          <li className="flex items-start" data-id="element-10">
            <span className="text-brand-gold mr-3 mt-1 flex-shrink-0 text-lg" data-id="element-11">
              ✔
            </span>
            <span className="text-brand-cream/90 font-sans leading-relaxed" data-id="element-12">
              {item}
            </span>
          </li>
        </FadeIn>)}
    </ul>;
}
export function StarList({
  items
}: ListProps) {
  return <ul className="grid gap-6" data-id="element-13">
      {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-14">
          <li className="flex items-center bg-brand-wineDark/30 p-4 rounded-lg border border-brand-gold/10" data-id="element-15">
            <span className="text-brand-gold mr-4 flex-shrink-0 text-xl" data-id="element-16">
              ✨
            </span>
            <span className="text-brand-cream font-sans font-medium" data-id="element-17">
              {item}
            </span>
          </li>
        </FadeIn>)}
    </ul>;
}